import React, { useState, useEffect } from 'react';
import {
    Row, Col, Input, Table, Label
} from 'reactstrap';
import { formatCurrency } from './currencyUtils';

const GetProducts = ({
    initialProducts = [],
    isEditing = false,
    disabled = false,
    totals = {} // total_amount datasını direkt alabiliriz
}) => {
    const [currencies] = useState(['TRY', 'USD', 'EUR', 'GBP']);
    const [stockTypes] = useState(['Adet', 'Kg', 'Metre', 'Litre']);
    const [selectedProducts, setSelectedProducts] = useState(initialProducts);
    const [displayCurrency, setDisplayCurrency] = useState('TRY');

    // Update products when initialProducts changes
    useEffect(() => {
        setSelectedProducts(initialProducts);
    }, [initialProducts]);

    const handleDisplayCurrencyChange = (e) => {
        setDisplayCurrency(e.target.value);
    };

    return (
        <div>
            {/* Header with title and currency selector */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-muted text-uppercase fw-semibold mb-0">Ürünler</h5>
                <div className="d-flex align-items-center">
                    <Label className="me-2 mb-0">Görüntüleme Para Birimi:</Label>
                    <Input
                        type="select"
                        value={displayCurrency}
                        onChange={handleDisplayCurrencyChange}
                        style={{ width: '120px' }}
                    >
                        {currencies.map(currency => (
                            <option key={currency} value={currency}>{currency}</option>
                        ))}
                    </Input>
                </div>
            </div>

            {/* Products table */}
            <div className="table-responsive">
                <Table className="table-borderless mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: '50px' }}>#</th>
                            <th>Ürün Bilgisi</th>
                            <th style={{ width: '120px' }}>Para Birimi</th>
                            <th style={{ width: '150px' }}>Birim Fiyat</th>
                            <th style={{ width: '100px' }}>Miktar</th>
                            <th style={{ width: '120px' }}>Birim</th>
                            <th style={{ width: '150px' }}>Toplam</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedProducts.map((product, index) => (
                            <tr key={product.id}>
                                <td>{index + 1}</td>
                                <td>
                                    <div>
                                        <h5 className="fs-14 mb-1">{product.product_name}</h5>
                                        <p className="text-muted mb-0">
                                            {product.product_code && `Kod: ${product.product_code}`}
                                            {product.additional_information &&
                                                <span className="ms-2">{product.additional_information}</span>
                                            }
                                        </p>
                                    </div>
                                </td>
                                <td>{product.currency}</td>
                                <td>{formatCurrency(product.sales_price_incl_vat, product.currency)}</td>
                                <td>{product.quantity}</td>
                                <td>{product.stock_type}</td>
                                <td>{formatCurrency(product.quantity * product.sales_price_incl_vat, product.currency)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="6" className="text-end">
                                <strong>Toplam ({displayCurrency}):</strong>
                            </td>
                            <td>
                                <strong>
                                    {formatCurrency(totals[displayCurrency] || 0, displayCurrency)}
                                </strong>
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};

export default GetProducts;